module.exports = __webpack_public_path__ + "static/media/add-button.dc79b51a.svg";